module.exports = __webpack_public_path__ + "static/media/group-member-select.91a17dd7.svg";